import { connect } from 'react-redux';
import {
  highlightShop, unhighlightShop, selectShop, showMap
} from '../actions';
import ShopListItem from '../components/ShopListItem';
import showCallbackButton from '../utilities/showCallbackButton';

const mapStateToProps = ({highlightedShop, selectedShop, config}, {shop}) => ({
  isHighlighted: highlightedShop == shop.parcelShopNumber,
  isSelected: selectedShop == shop.parcelShopNumber,

  showCallbackButton: showCallbackButton(config, shop),
  showMapLink: !config.callbackUrl,
  showDetailLink: true,
  showRouteLink: !config.callbackUrl,
  sortCode1: config.sortCode1
});

const mapDispatchToProps = dispatch => ({
  onClick: (parcelShopNumber) => {
    dispatch(showMap());
    dispatch(selectShop(parcelShopNumber));
  },

  onMouseOver: (parcelShopNumber) => {
    dispatch(highlightShop(parcelShopNumber))
  },

  onMouseOut: () => {
    dispatch(unhighlightShop());
  },

  onMapClick: (parcelShopNumber) => {
    dispatch(showMap());
    dispatch(selectShop(parcelShopNumber));
  }
});

const ShopListItemContainer = connect(mapStateToProps, mapDispatchToProps)(ShopListItem)

export default ShopListItemContainer;
